export * from './consumer.type'

// 允许打开独立页面的文件类型
export const allowOpenFileExtensions = [
  '.html',
  '.txt',
  '.mobi',
  '.epub',
  '.url',
]

export const checkAllowOpenFileExtensions = (fileExtension: string) => {
  const extension = fileExtension.toLowerCase()
  return allowOpenFileExtensions.includes(extension)
}
